<div class="add-membership-modal" *ngIf="isVisible" (click)="closeModal($event)">
  <div class="add-membership-modal__content" (click)="$event.stopPropagation()">
    <h2 class="add-membership-modal__title">
      {{ modalTitle }}
    </h2>

    <form [formGroup]="addMembershipForm" (ngSubmit)="onSubmit()">
      <div class="add-membership-modal__inputs-container">
        <!-- Toggle: Published / Draft -->
        <div class="add-membership-modal__toggle-container" *ngIf="planType !== 'b2b' || b2bStep === 1">
          <span [class.active]="addMembershipForm.get('isPublished')?.value">Published</span>
          <label class="toggle-switch">
            <input type="checkbox" formControlName="isPublished" />
            <span class="slider"></span>
          </label>
          <span [class.active]="!addMembershipForm.get('isPublished')?.value">Draft</span>
        </div>

        <!-- Membership Title -->
        <div class="add-membership-modal__input-container" *ngIf="planType !== 'b2b' || b2bStep === 1">
          <label for="membership-name" class="add-membership-modal__label">Title</label>
          <input
            id="membership-name" type="text" formControlName="name" class="add-membership-modal__input" required/>
        </div>

        <!-- Membership Subtitle -->
        <div class="add-membership-modal__input-container" *ngIf="planType !== 'b2b'">
          <label for="membership-subtitle" class="add-membership-modal__label">Subtitle</label>
          <input id="membership-subtitle" type="text" formControlName="subtitle" class="add-membership-modal__input"/>
        </div>

        <!-- Membership Description -->
        <div class="add-membership-modal__input-container" *ngIf="planType !== 'b2b' || b2bStep === 1">
          <label for="membership-description" class="add-membership-modal__label">Description</label>
          <div class="add-membership-modal__editor-wrapper">
            <quill-editor
              id="membership-description"
              formControlName="description"
              [modules]="editorModules"
              placeholder=" "
              (onContentChanged)="onEditorContentChanged($event)"
              class="add-membership-modal__editor"
            ></quill-editor>

            <span class="add-membership-modal__resize-handle" (mousedown)="resizeTextarea($event)"></span>
          </div>
        </div>

        <!-- What your team gets (B2B step 2) -->
        <div class="add-membership-modal__benefits" *ngIf="planType === 'b2b' && b2bStep === 2" formArrayName="benefits">
          <p class="add-membership-modal__section-title">What your team gets</p>

          <div
            class="benefit-block"
            *ngFor="let benefit of benefitsArray.controls; let i = index"
            [formGroupName]="i"
          >
            <span class="add-membership-modal__label">Benefit</span>
            <div class="benefit-block__card">
              <span class="add-membership-modal__label">Icon</span>
              <div class="benefit-icon-select">
                <button
                  type="button"
                  class="benefit-icon-select__trigger"
                  (click)="toggleIconPicker(i)"
                  [attr.aria-expanded]="openIconPickerIndex === i"
                  aria-label="Select benefit icon"
                >
                  <span
                    class="benefit-icon-select__plate"
                    [class.benefit-icon-select__plate--plated]="benefitIconIncludesPlate(benefit.get('icon')?.value)"
                  >
                    <img [src]="benefitIconSrc(benefit.get('icon')?.value)" alt="" aria-hidden="true" />
                  </span>
                  <img
                    class="benefit-icon-select__chevron"
                    src="/assets/icons/mingcute_down-line.svg"
                    alt=""
                    aria-hidden="true"
                  />
                </button>
                <div class="benefit-icon-select__menu" *ngIf="openIconPickerIndex === i" role="listbox">
                  <button
                    type="button"
                    class="benefit-icon-select__option"
                    *ngFor="let key of benefitIconKeys"
                    (click)="selectBenefitIcon(i, key)"
                    [attr.aria-label]="key"
                  >
                    <span
                      class="benefit-icon-select__plate"
                      [class.benefit-icon-select__plate--plated]="benefitIconIncludesPlate(key)"
                    >
                      <img [src]="benefitIconSrc(key)" alt="" aria-hidden="true" />
                    </span>
                  </button>
                </div>
              </div>

              <label class="add-membership-modal__label" [attr.for]="'benefit-description-' + i">Description</label>
              <div class="add-membership-modal__editor-wrapper">
                <quill-editor
                  [id]="'benefit-description-' + i"
                  formControlName="description"
                  [modules]="editorModules"
                  placeholder=" "
                  class="add-membership-modal__editor"
                ></quill-editor>
              </div>
            </div>

            <div class="benefit-block__actions">
              <button type="button" class="benefit-block__add" (click)="addBenefit()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor" />
                </svg>
                ADD BENEFIT
              </button>
              <button
                type="button"
                class="benefit-block__remove"
                *ngIf="benefitsArray.length > 1"
                (click)="removeBenefit(i)"
              >
                REMOVE
              </button>
            </div>
          </div>
        </div>

        <!-- Stripe Payment Link -->
        <div class="add-membership-modal__input-container" *ngIf="planType !== 'b2b' || b2bStep === 1">
          <label for="stripe-payment-link" class="add-membership-modal__label">Stripe payment link</label>
          <input
            id="stripe-payment-link"
            type="text"
            formControlName="stripePaymentLink"
            class="add-membership-modal__input"
            [required]="planType !== 'b2b'"
            [disabled]="!!addMembershipForm.get('stripePaymentLink')?.disabled"
          />
        </div>

        <!-- Stripe Pricing Link -->
        <div class="add-membership-modal__input-container" *ngIf="planType !== 'b2b' || b2bStep === 1">
          <label for="stripe-pricing-link" class="add-membership-modal__label">Stripe pricing link</label>
          <input
            id="stripe-pricing-link"
            type="text"
            formControlName="stripePricingLink"
            class="add-membership-modal__input"
            required
            [disabled]="!!addMembershipForm.get('stripePricingLink')?.disabled"
          />
        </div>

        <!-- Billing Cycle (B2C and B2C Promotion) -->
        <div class="add-membership-modal__input-container" *ngIf="planType === 'b2c' || planType === 'b2c-promotion'">
          <label class="add-membership-modal__label">Billing Cycle</label>
          <div class="add-membership-modal__radio-group">
            <label class="radio-container">
              <input
                type="radio"
                formControlName="billingCycle"
                value="Month"
                [disabled]="!!addMembershipForm.get('billingCycle')?.disabled"
              />
              <span class="custom-radio"></span>
              Month
            </label>
            <label class="radio-container">
              <input
                type="radio"
                formControlName="billingCycle"
                value="Annual"
                [disabled]="!!addMembershipForm.get('billingCycle')?.disabled"
              />
              <span class="custom-radio"></span>
              Annual
            </label>
          </div>
        </div>

        <!-- Trial Period (B2C and B2C Promotion) -->
        <div class="add-membership-modal__input-container" *ngIf="showTrialDays">
          <label for="trial-days" class="add-membership-modal__label">Trial setup</label>
          <input
            id="trial-days"
            type="number"
            formControlName="trialDays"
            class="add-membership-modal__input"
            min="0"
            step="1"
          />
        </div>
      </div>

      <!-- B2B step 1 buttons -->
      <div class="add-membership-modal__buttons" *ngIf="planType === 'b2b' && b2bStep === 1">
        <app-button variant="main" size="md" type="button" [disabled]="isB2bStep1Invalid" (click)="onB2bContinue()">
          CONTINUE
        </app-button>

        <app-button variant="secondary" size="md" type="button" (click)="closeModal($event)"> CANCEL </app-button>
      </div>

      <!-- B2B step 2 buttons -->
      <div class="add-membership-modal__buttons" *ngIf="planType === 'b2b' && b2bStep === 2">
        <app-button variant="secondary" size="md" type="button" (click)="onB2bBack()"> BACK </app-button>

        <app-button variant="main" size="md" [isLoading]="isLoading" [disabled]="isFormInvalid">
          <span *ngIf="isLoading" class="app-spinner app-spinner--inline"></span>
          <span *ngIf="!isLoading">{{ isEditMode ? "UPDATE" : "ADD" }}</span>
        </app-button>

        <app-button variant="secondary" size="md" type="button" (click)="closeModal($event)"> CANCEL </app-button>
      </div>

      <!-- B2C buttons -->
      <div class="add-membership-modal__buttons" *ngIf="planType !== 'b2b'">
        <app-button variant="main" size="md" [isLoading]="isLoading" [disabled]="isFormInvalid">
          <span *ngIf="isLoading" class="app-spinner app-spinner--inline"></span>
          <span *ngIf="!isLoading">{{ isEditMode ? "UPDATE" : "ADD" }}</span>
        </app-button>

        <app-button variant="secondary" size="md" type="button" (click)="closeModal($event)"> CANCEL </app-button>
      </div>

      <!-- Error Message -->
      <div *ngIf="errorMessage" class="add-membership-modal__error-text">
        {{ errorMessage }}
      </div>
    </form>
  </div>
</div>
